import { setCookie } from "@/utils/cookie";
import { CookieList } from "@/utils/enums";

const setLanguageCookie = (languageCode: string) => {
    setCookie(CookieList.LANGUAGE, languageCode, 30);
};

export { setLanguageCookie };
